import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { images } from "../../data/site";
export function StorySection() {
  return <section className="mx-auto max-w-[1320px] px-5 py-24 md:px-10 md:py-32" aria-labelledby="story-title" data-id="element-127" data-mp="3na19vw0scoyp">
      <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-128" data-mp="3ib7t9uq7chub">
        <div className="relative lg:col-span-5" data-id="element-129" data-mp="3i93svmrii0ys">
          <img src={images.archive1978} alt="Jean-Claude Bétemps et André Bohn déplient leur voile sur la pente en 1978" className="aspect-[4/5] w-full rounded-[28px] object-cover" data-id="element-130" data-mp="3eae653kl372h" />
          <p className="absolute -bottom-6 right-6 rounded-2xl bg-navy px-6 py-4 font-serif text-cream md:-right-8" data-id="element-131" data-mp="34anf5bv8fa75">
            <span className="block text-4xl leading-none" data-id="element-132" data-mp="2zd5cg37t5r7l">25.06.1978</span>
            <span className="mt-1 block text-sm font-sans text-cream/80" data-id="element-133" data-mp="12kbxdpnk1f96">Décollage du Pertuiset</span>
          </p>
        </div>

        <div className="lg:col-span-7" data-id="element-134" data-mp="xm0njex9f4qy">
          <h2 id="story-title" className="font-serif text-4xl leading-[1.1] md:text-6xl" data-id="element-135" data-mp="xiwcbxldn8qs">
            Deux pionniers, une pente, <span className="italic" data-id="element-136" data-mp="26yjijmt8cg0k">un sport inventé.</span>
          </h2>
          <div className="mt-8 grid gap-6 text-lg leading-relaxed text-navy-soft md:grid-cols-2" data-id="element-137" data-mp="26wggu5ipsyg0">
            <p data-id="element-138" data-mp="1s3wswc44yxj5">
              Ce jour-là, Jean-Claude Bétemps et André Bohn tentent ce que personne n'avait imaginé : décoller à pied, depuis une pente, sous une voile de parachute.
            </p>
            <p data-id="element-139" data-mp="2ksapcnfktlsl">
              Leur vol depuis le Pertuiset fait de Mieussy le berceau mondial du parapente. Cinquante ans plus tard, le village rend hommage à cette audace.
            </p>
          </div>

          <dl className="mt-12 grid grid-cols-3 border-t border-navy/15 pt-8" data-id="element-140" data-mp="2ayk4rtmklvi6">
            <div data-id="element-141" data-mp="2fxoh2t4sk9cq">
              <dt className="text-sm text-navy-soft" data-id="element-142" data-mp="2fx4wf4nrb6v0">Années de vol libre</dt>
              <dd className="mt-1 font-serif text-5xl" data-id="element-143" data-mp="33nr5mz9hyx6l">50</dd>
            </div>
            <div data-id="element-144" data-mp="38gk79e9o5peg">
              <dt className="text-sm text-navy-soft" data-id="element-145" data-mp="38h3h07p617he">Pionniers</dt>
              <dd className="mt-1 font-serif text-5xl" data-id="element-146" data-mp="3iapsegxet3ez">2</dd>
            </div>
            <div data-id="element-147" data-mp="3dc662fewlpm3">
              <dt className="text-sm text-navy-soft" data-id="element-148" data-mp="3ddr10654rakh">Berceau mondial</dt>
              <dd className="mt-1 font-serif text-5xl" data-id="element-149" data-mp="39auei4cgyub9">1</dd>
            </div>
          </dl>

          <Link to="/histoire" className="group mt-10 inline-flex items-center gap-2 font-semibold text-navy" data-id="element-150" data-mp="34bztcvr14tnz">
            <span className="border-b border-navy pb-0.5" data-id="element-151" data-mp="2zdg9d0vzxry9">Lire toute l'histoire</span>
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-1" data-id="element-152" data-mp="2um6i5vusugk9" />
          </Link>
        </div>
      </div>
    </section>;
}